import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import FakeButton from '@stories/Components/Global/Buttons/FakeButton/FakeButton';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from '../DesktopNavigation.styles';
const FeaturedCard = (props) => {
    const srcs = getSrcs(props.image, 468, 200, 4, props.site, 426 / 268);
    const sizes = `${until(Device.ActualDesktop)} 25vw, 468px`;
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.FeaturedCard, { ...(!props.url ? { as: 'span' } : { href: props.url, target: props.target }) },
            React.createElement(S.FeaturedCardImageWrapper, null,
                React.createElement(S.FeaturedCardImage, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image.altText ?? props.title, loading: "lazy" }),
                props.tag && React.createElement(S.FeaturedCardTag, null, props.tag)),
            React.createElement(S.FeaturedCardTitle, null, props.title),
            React.createElement(S.FeaturedCardContent, null, props.content),
            props.url && (React.createElement(FakeButton, { buttonType: "link", site: props.site }, props.text)))));
};
export default FeaturedCard;
